export default "__VITE_ASSET__DuQeiP8b__"